import { t } from '@lingui/macro';

export enum SectorOfActivities {
  Undefined = 0,
  Insurance = 1,
  Bank = 2,
  InsuranceAndBank = 3,
  Credit = 4,
  Leasing = 5
}

export const getSectorOfActivityLabel = (sectorOfActivity) => {
  switch (sectorOfActivity) {
    case SectorOfActivities.Insurance:
      return t`assurances`;
    case SectorOfActivities.Bank:
      return t`banque`;
    case SectorOfActivities.InsuranceAndBank:
      return t`banque et assurances`;
    case SectorOfActivities.Credit:
      return t`crédit`;
    case SectorOfActivities.Leasing:
      return t`leasing`;
    default:
      break;
  }
};

export const sectorOfActivitiesLabels = [
  { value: SectorOfActivities.Insurance },
  { value: SectorOfActivities.Bank },
  { value: SectorOfActivities.InsuranceAndBank },
  { value: SectorOfActivities.Credit },
  { value: SectorOfActivities.Leasing }
];
